import React, { useEffect, useState} from "react";
import Carrito from '../cart/carrito/Carrito';
import { Icon } from "semantic-ui-react";
import jwtDecode from "jwt-decode";
import { getToken, removeToken } from "../../api/token";

export default function Nav(props) {
  const {getProductsCart, productsCart} = props;
  const [iduser, setIduser] = useState(null)

  useEffect(() => {
    const token = getToken();     
    if(token){
      setIduser(jwtDecode(token).data.user.id);
    } 

  }, [])

  const cerrarSesion = () => {
    removeToken();
    window.location.href='./';
}
  return (
//"marginBottom": "15px"
    <nav className="navbar navbar-expand-sm bg-dark navbar-dark dark">
      <a href="./">
      {!iduser ? (<p style={{"marginBottom": "15px", "color":"white", "fontSize":"25px", "fontFamily":"Lobster, cursive"}}>
        Inversiones Masdel, S.A Distribuidor Exclusivo Autorizado de Mary Kay
     </p>): (
                   <p style={{"marginBottom": "15px", "color":"white", "fontSize":"20px", "fontFamily":"Lobster, cursive"}}>
                   Inversiones Masdel, S.A Distribuidor Exclusivo Autorizado de Mary Kay
                </p>
                )}
      
      </a>
     
    <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavbar"
    >
        <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="collapsibleNavbar">
        <ul className="navbar-nav">
        <li className="nav-item">
            <a className="nav-link" href="#/">
            
            </a>
        </li>
        <li className="nav-item">
            <a className="nav-link" href="#/">
            
            </a>
        </li>
        <li className="nav-item">
            <a className="nav-link" href="#/">
            
            </a>
        </li>
        </ul>
        </div>
     <ul className="nav navbar-nav navbar-right">
        <li className="dropdown contenedor-modal">
            {!iduser ?  <a className="btn" href="./">
                     <Icon name="user" size="big" color='red' />
                    <p style={{"color": "white"}}>
                      Iniciar Sesión
                    </p>
                  </a> : (
                   <button className="btn" onClick={()=>cerrarSesion()}>
                     <Icon name="log out" size="big" color='red' />
                    <p style={{"color": "white"}}>
                      Cerrar Sesión
                    </p>
                  </button>
                )}
               
        </li>
          <li className="dropdown contenedor-modal">
          <Carrito getProductsCart={getProductsCart}  productsCart={productsCart}/>
          
          </li>
        </ul>
    </nav>

   
    
  );

}
/**
 * 
       

        <nav className="navbar navbar-default" role="navigation">
      <div className="navbar-header">
        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
          <span className="sr-only">Desplegar navegación</span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
            </button>
          <a class="navbar-brand" href="#">
              <img style={{"width" : "155px", "height": "30px", "marginBottom": "15px"}} src={logo} alt=""/>
          </a>
        </div>
    
        <ul className="nav navbar-nav navbar-right">
          <li className="dropdown col-2 contenedor-modal">
          <Carrito />
          
          </li>
        </ul>
    </nav>
 */